var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTfaCodeIos(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.667,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7737",
    d: "M0 21.533V12.38q0-2.376 1.923-2.464V7.334C1.923 2.934 4.487 0 8.333 0s6.41 2.934 6.41 7.334v2.582q1.923.176 1.923 2.464v9.153c0 1.7-.758 2.464-2.331 2.464H2.272Q0 24.085 0 21.533zM4.6 9.857h7.459V6.982c0-2.64-1.515-4.459-3.73-4.459-2.273 0-3.73 1.819-3.73 4.459z",
    fill: "#fff"
  })));
}
export default SvgTfaCodeIos;